import React, { Component }  from 'react';
import { withRouter }        from 'react-router';
import { connect }           from 'react-redux';
import { Redirect }          from 'react-router-dom';
import SystemsBreadcrumb     from './Breadcrumb';
import Provision             from './User/Provision';
import { SystemsConstants }  from './environment';
import Required              from '../../Required';
import { isLoggedIn }        from '../../../utils/authService';
import { isInRoleFromToken } from '../../../utils/authService';
import { redirect }          from '../../../utils/authService'; 

class Systems extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | Systems';
  }

  render() {
    var path = this.props.location.pathname.toLowerCase();    
    if (!isLoggedIn()) {
      redirect(path.replace(/^\/|\/$/g, ''));
      return (
        <Required />
      );
    }
        
    let content = null;
    if (isInRoleFromToken(SystemsConstants.UserRole)) {
      let component = null;
      if (path.endsWith(SystemsConstants.PathPrefix)) {
        component = <Provision />;
      }
      else if (path.startsWith(SystemsConstants.UserPathPrefix + '/provision')) {
        component = <Provision />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <SystemsBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      return <Redirect to='/404' />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  systems: state.systems
});

export default withRouter(connect(mapStateToProps)(Systems));
